import React ,{useState,useEffect} from 'react';
import TitleTopbarBack from 'components/fixbar/TitleTopbarBack';
import Modal from 'components/modal/Modal';
import Calendar from 'components/calendar/Calendar';
import GroupPjChangeTermDayckcal from 'components/grouppage/groupdtail/GroupPjChangeTermDayckcal';
import ModalText from 'components/modal/ModalText';
import { RoutinelistAddInner, Calinner, RoutinelistAddTop, Toptext, Topday, Checkday } from './style';

export default function RoutineSelectCalendar({updateNext,setRutineDay,setRutineWeek,titleText,setSubmitDay,setSelectResult,selectResult}) {
    const [showModal, setShowModal] = useState(false);
    const [textModalShow,setTextModalShow] = useState(false);
    const [modalOption ,setModalOption] = useState("");
    

    const [selectDay,setSelectDay] = useState(new Date().toDateString());
    const [unselectDay,setUnselectDay] = useState(false);

    const [selectList,setSelectList] = useState([ {},{},{},{},{},{},{} ]);
    

    useEffect(()=>{
        setRutineDay(selectDay);
    },[selectDay]);

    const textDate = {"일":"sun","월":"mon","화":"tue","수":"wed","목":"thu","금":"fri","토":"sat"}
    const checkSelectItemList = (index,daytxn) =>{
        var result = "";
        var tempList = selectList;
        if(tempList[index].daytxn)
            tempList[index] = {};
        else{ 
            tempList[index].daytxn = daytxn;
        }
           
        tempList.map((value ,index)=>{
            result += value.daytxn ? (value.daytxn +  ",") : "";
            return value.daytxn ? (value.daytxn + (selectList.length -1 == index ? "" : ",")) : "";
        }) 

        setSelectResult(result.slice(0, -1));
        setSelectList(tempList);
        // 영문으로 변환
        let textDayList = []; 
        result.slice(0,-1).split(',').map((value)=>{ 
        textDayList.push(textDate[value]);
        })
        setRutineWeek(textDayList);
    }

 
    const prevpage =()=> {
        setRutineDay(false);
        setRutineWeek(false);
        setSelectList([ {},{},{},{},{},{},{} ]);
        updateNext(-1);
    }

    // 완료 누르시 모달 리스트
    useEffect(()=>{
        if(modalOption === "routineSeletboth" || modalOption === "routineSeletDay" || modalOption === "routineSeletWeek"){
            setTextModalShow(true);
        }
        else if(modalOption !== "")
            setTextModalShow(false);
    },[modalOption]);

    const finishClick =()=> {
        if(unselectDay === false && selectResult === false) {
            // alert("날짜/요일 선택 해주세요")
            setModalOption("routineSeletboth");
        } else if (unselectDay === false) {
            // alert("날짜 선택 해주세요")
            setModalOption("routineSeletDay");
        } else if (selectResult === false) {
            // alert("요일 선택 해주세요")
            setModalOption("routineSeletWeek");
        } else {
            // alert("완료")
            updateNext(-1);
        }
    }

    return(

        <RoutinelistAddInner>
            <TitleTopbarBack 
                setShowModal={setShowModal}
                title={titleText}
                borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"} 
                finishClick={finishClick}
            />
            
            <RoutinelistAddTop>
                <Toptext>루틴 시작 날짜</Toptext>
                    {
                        unselectDay ?
                        <Topday>{selectDay}</Topday>
                        :
                        <Topday></Topday>
                    }

            </RoutinelistAddTop>
    
            <Calinner>
                <Calendar
                    setSelectDay={setSelectDay} 
                    setUnselectDay={setUnselectDay}
                    setSubmitDay={setSubmitDay}
                />
            </Calinner>

            <RoutinelistAddTop bordertop={"solid calc(100vw*(1/375)) #d8d8d8"}>
                <Toptext>루틴 요일</Toptext>
                <Topday>
                {
                   selectResult    
                }
                </Topday>
            </RoutinelistAddTop>

            <Checkday>
                <GroupPjChangeTermDayckcal checkSelectItemList={checkSelectItemList}/>
            </Checkday>


            {/* <Delbottom/> */}
            <Modal
             setShowModal={setShowModal}
             showModal={showModal}
             title={"루틴 추가 취소 "} 
             subtitle={"루틴 추가를 취소하시겠어요? "} 
             background={"rgba(0,0,0,0.36)"}
             submitClick={prevpage}
             setModalOption={setModalOption}
             />
             <ModalText 
                setTextModalShow={setTextModalShow}
                textModalShow={textModalShow}
                modalOption={modalOption}
                />
        </RoutinelistAddInner>
    )
}


